export type PostImageType = {
  fields: {
    file: {
      url: string
      details: {
        image: {
          width: number
          height: number
        }
      }
    }
    title: string
  }
  sys?: {
    createdAt: string
    updatedAt: string
  }
}

type PostImageProps = {
  content: PostImageType
}

export const PostImage = ({ content }: PostImageProps) => {
  if (!content?.fields?.file) return null

  return <img src={`https:${content.fields.file.url}`} alt={content.fields.title} />
}
